import React, { useState, useEffect } from "react";
import i18n from "i18next";
import SendMail from "../SendMail/SendMail";
import { fetchWrapper } from "../../../helpers/fetchwrapper";
import { baseUrl } from "../../../helpers/constants";
import useWindowSize from "../../../helpers/useWindowSize";
import { renderDetailsHeader } from "../../../helpers/renderDetailsListHeader";
import DialogDeleteUser from "./DialogDeleteUser";
import {
  Combobox,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  Dropdown,
  Option,
  Field,
  Tab,
  TabList,
  Input,
  Checkbox,
  TableColumnDefinition,
  createTableColumn,
  MessageBar,
  MessageBarBody,
  Button,
  Spinner,
} from "@fluentui/react-components";
import {
  CheckmarkFilled,
  DismissFilled,
  PersonArrowRightRegular,
  ShareAndroidRegular,
} from "@fluentui/react-icons";
import { IAppUserDto } from "../../../Models/IAppUserDto";
import { StackItemShim, StackShim } from "@fluentui/react-migration-v8-v9";
import { IUserProduct } from "../../../Models/IUserProduct";
import LuebPagedDataGrid from "../../../Controls/LuebPagedDataGrid";
import { EmailColumns } from "../../Sales/Emails/EmailColumns";
import { IEmail } from "../../../Models/IEmails";

interface IEditUserPageProps {
  onSave(): void;
  user: IAppUserDto;
  isDialogDeleteUserOpen: boolean;
  closeDialogDeleteUser(): void;
  saveEditedUser: boolean;
  disabledSaveButton(item: boolean): void;
  sendMail: boolean;
  sendMailButtonDisabled(item: boolean): void;
  selectedTabChange(item: string): void;
  onEmailSelect(item: IEmail): void;
  setEmailUndefined: boolean;
  getEmails: boolean;
  getRegisteredProducts: boolean;
}

function EditUserPage(props: IEditUserPageProps) {
  const [freigabeAlleProdukteDisabled, setFreigabeAlleProdukte] =
    useState<boolean>(false);

  const [selectedTabValue, setSelectedTabValue] = useState<string>("editUser");
  const [hasUserOpenRoleRequests, setHasUserOpenRoleRequests] = useState(false);
  const [deleteUserDialogIsOpen, setDeleteUserDialogIsOpen] =
    useState<boolean>(false);
  const [editUser, setEditUser] = useState<IAppUserDto>(props.user);
  const [countries, setCountries] = useState<{ key: string; text: string }[]>(
    [],
  );

  const [toolHersteller, setToolHersteller] = useState<
    { key: string; text: string }[]
  >([]);
  const [selectedToolHerstellerKeys, setSelectedToolHerstellerKeys] = useState<
    string[]
  >([]);

  const [arbeitsgebiete, setArbeitsgebiete] = useState<
    { key: string; text: string }[]
  >([]);
  const [selectedArbeitsgebieteKeys, setSelectedArbeitsgebieteKeys] = useState<
    string[]
  >([]);

  const [branchen, setBranchen] = useState<{ key: string; text: string }[]>([]);
  const [selectedBranchenKeys, setSelectedBranchenKeys] = useState<string[]>(
    [],
  );

  const [roles, setRoles] = useState<{ key: string; text: string }[]>([]);
  const [selectedRoleKeys, setSelectedRoleKeys] = useState<string[]>([]);

  const [userProducts, setUserProducts] = useState({
    ownProductslist: [],
    sharedProductslist: [],
  });

  const emailColumns = EmailColumns({
    onClickedEmail: (item: IEmail) => {
      setSelectedMail(item);
      props.onEmailSelect(item);
    },
  });

  const [emails, setEmails] = useState<any[]>([]);
  const [selectedMail, setSelectedMail] = useState<IEmail>();

  const [deleteError, setDeleteError] = useState("");

  const [transferDialogOpen, setTransferDialogOpen] = useState(false);
  const [transferTargetUser, setTransferTargetUser] = useState<IAppUserDto>();
  const [transferring, setTransferring] = useState(false);
  const [transferResult, setTransferResult] = useState<"success" | "error">();
  const [transferErrorMessage, setTransferErrorMessage] = useState<string>();
  const [dialogUsers, setDialogUsers] = useState<IAppUserDto[]>([]);
  const [loadingDialogUsers, setLoadingDialogUsers] = useState(false);

  const [templateBody, setTemplateBody] = useState("");

  const getTemplateBody = (lang: string) => {
    fetchWrapper
      .get(baseUrl + "/api/emailtemplate/GetTemplateBody?lang=" + lang)
      .then((result: any) => {
        setTemplateBody(result.body);
      });
  };

  const getAllEmails = () => {
    if (props.user && props.user.email) {
      fetchWrapper
        .getWithAuth(
          `${baseUrl}/api/vertrieb/GetAllEmailsForUser?email=${props.user.email}`,
        )
        .then((data: any) => {
          setEmails(data);
        });
    }
  };
  const columns: TableColumnDefinition<IUserProduct>[] = [
    createTableColumn<IUserProduct>({
      columnId: "seriennummerId",
      compare: (a, b) => {
        if (a.seriennummer && b.seriennummer) {
          return a.seriennummer.localeCompare(b.seriennummer);
        } else return 0;
      },
      renderHeaderCell: () => {
        return i18n.t<string>("productId");
      },
      renderCell: (item) => {
        return <div>{item.seriennummer}</div>;
      },
    }),
    createTableColumn<IUserProduct>({
      columnId: "bennenungId",
      compare: (a, b) => {
        if (i18n.language.includes("de")) {
          return a.benennungDE.localeCompare(b.benennungDE);
        } else return a.benennungEN.localeCompare(b.benennungEN);
      },
      renderHeaderCell: () => {
        return i18n.t<string>("benennung");
      },
      renderCell: (item) => {
        return (
          <div>
            {i18n.language.includes("de") ? item.benennungDE : item.benennungEN}
          </div>
        );
      },
    }),
    createTableColumn<IUserProduct>({
      columnId: "kundenProduktNummerId",
      compare: (a, b) => {
        if (a.kundenProduktNummer && b.kundenProduktNummer) {
          return a.kundenProduktNummer.localeCompare(b.kundenProduktNummer);
        } else return 0;
      },
      renderHeaderCell: () => {
        return i18n.t<string>("userProductNumber");
      },
      renderCell: (item) => {
        return <div>{item.kundenProduktNummer}</div>;
      },
    }),
    createTableColumn<IUserProduct>({
      columnId: "kundenProdukttextId",
      compare: (a, b) => {
        if (a.kundenProdukttext && b.kundenProdukttext) {
          return a.kundenProdukttext.localeCompare(b.kundenProdukttext);
        } else return 0;
      },
      renderHeaderCell: () => {
        return i18n.t<string>("userProductText");
      },
      renderCell: (item) => {
        return <div>{item.kundenProdukttext}</div>;
      },
    }),
  ];

  const getCountries = () => {
    fetchWrapper.get(`${baseUrl}/api/account/getcountries`).then((result) => {
      let options: { key: string; text: string }[] = [];
      result.forEach((element: any) => {
        let option: { key: string; text: string } = {
          key: element.landGuid,
          text: i18n.language.includes("de")
            ? element.name_DE
            : element.name_EN,
        };
        options.push(option);
      });

      options.sort((a, b) => a.text.localeCompare(b.text));

      setCountries(options);
    });
  };

  const getRoles = () => {
    fetchWrapper
      .getWithAuth(`${baseUrl}/api/account/getallroles`)
      .then((result) => {
        let options: { key: string; text: string }[] = [];

        result.forEach((element: any) => {
          let option: { key: string; text: string } = {
            key: element.id,
            text: element.name,
          };
          options.push(option);
        });
        setRoles(options);
      })
      .catch((error) => {});
  };

  const getRolesForUser = () => {
    fetchWrapper
      .postWithAuth(`${baseUrl}/api/account/GetRolesForUser`, {
        UserId: props.user.id,
      })
      .then((result: any) => {
        let keys: string[] = [];
        result.forEach((element: any) => {
          keys.push(element.id);
        });
        setSelectedRoleKeys(keys);
      })
      .catch((error: any) => {});
  };

  const getToolHersteller = () => {
    fetchWrapper
      .get(`${baseUrl}/api/account/getalltoolhersteller`)
      .then((result: any) => {
        let options: { key: string; text: string }[] = [
          { key: "42", text: i18n.t<string>("all") },
        ];

        result.forEach((element: any) => {
          let option: { key: string; text: string } = {
            key: element.toolherstellerGuid,
            text: i18n.language.includes("de")
              ? element.nameDE
              : element.nameEN,
          };
          options.push(option);
        });
        setToolHersteller(options);
      });
  };

  const getBranchen = () => {
    fetchWrapper
      .get(`${baseUrl}/api/account/GetBranchen`)
      .then((result: any) => {
        let options: { key: string; text: string }[] = [];

        result.forEach((element: any) => {
          let option: { key: string; text: string } = {
            key: element.brancheGuid,
            text: i18n.language.includes("de")
              ? element.nameDE
              : element.nameEN,
          };
          options.push(option);
        });
        setBranchen(options);

        //Jetzt Branchen des Benutzers laden
        getBranchenForUser();
      });
  };

  const getArbeitsgebiete = () => {
    fetchWrapper
      .get(`${baseUrl}/api/account/GetArbeitsgebiete`)
      .then((result: any) => {
        let options: { key: string; text: string }[] = [];

        result.forEach((element: any) => {
          let option: { key: string; text: string } = {
            key: element.arbeitsgebietGuid,
            text: i18n.language.includes("de")
              ? element.nameDE
              : element.nameEN,
          };
          options.push(option);
        });
        setArbeitsgebiete(options);

        // Jetzt Arbeitsgebiete des Users laden
        getArbeitsgebieteForUser();
      });
  };

  const getBranchenForUser = () => {
    fetchWrapper
      .post(baseUrl + "/api/account/GetBranchenForUser", {
        UserGuid: props.user.id,
      })
      .then((result: any) => {
        let keys: string[] = [];
        result.forEach((element: any) => {
          keys.push(element.brancheGuid);
        });
        setSelectedBranchenKeys(keys);
      })
      .catch((error: any) => {});
  };

  const getArbeitsgebieteForUser = () => {
    fetchWrapper
      .post(baseUrl + "/api/account/GetArbeitsgebieteForUser", {
        UserGuid: props.user.id,
      })
      .then((result: any) => {
        let keys: string[] = [];
        result.forEach((element: any) => {
          keys.push(element.arbeitsgebietGuid);
        });
        setSelectedArbeitsgebieteKeys(keys);
      })
      .catch((error: any) => {});
  };

  const getToolHerstellerForUser = () => {
    fetchWrapper
      .post(baseUrl + "/api/account/gettoolherstellerforuser", {
        UserGuid: props.user.id,
      })
      .then((result: any) => {
        let keys: string[] = [];
        result.forEach((element: any) => {
          keys.push(element.toolherstellerGuid);
        });

        if (keys.length == toolHersteller.length - 1) {
          keys.push("42");
        }

        setSelectedToolHerstellerKeys(keys);
      })
      .catch((error: any) => {});
  };

  function onChangeBranchenForUser(key: string, selectedItems: string[]) {
    if (key) {
      setSelectedBranchenKeys(selectedItems);
      if (selectedItems.includes(key)) {
        // Set DB Entry for this user
        fetchWrapper
          .post(baseUrl + "/api/account/SetBrancheForUser", {
            UserGuid: props.user.id,
            BrancheGuid: key,
          })
          .then((result: any) => {})
          .catch((error: any) => {});
      } else {
        // Remove DB Entry for this user
        fetchWrapper
          .post(baseUrl + "/api/account/RemoveBrancheForUser", {
            UserGuid: props.user.id,
            BrancheGuid: key,
          })
          .then((result: any) => {})
          .catch((error: any) => {});
      }
    }
  }

  const freigabeAlleProdukteUser = () => {
    fetchWrapper
      .get(
        baseUrl + "/api/account/freigabeAlleProdukteUser?userId=" + editUser.id,
      )
      .then((result: any) => {
        alert("Ok");
      });
  };

  const loadDialogUsers = () => {
    setLoadingDialogUsers(true);
    fetchWrapper
      .postWithAuth(`${baseUrl}/api/account/getbyquery`, {
        vorname: "",
        nachname: "",
        firma: "",
        eMail: "",
        kundennummer: "",
        stadt: "",
        sprache: "",
        rollen: [],
        onlyDemo: false,
        isDeleted: 0,
        IsVerified: 2,
        deleteRequested: 2,
        hasFaultyRoleAssignment: false,
        configuratorButNoTools: 0,
        preiseSichtbar: 2,
      })
      .then((result: IAppUserDto[]) => {
        setDialogUsers(
          result.sort((a, b) => a.nachname.localeCompare(b.nachname)),
        );
      })
      .catch(() => {})
      .finally(() => setLoadingDialogUsers(false));
  };

  const transferUserProducts = () => {
    if (!transferTargetUser) return;
    setTransferring(true);
    setTransferResult(undefined);
    fetchWrapper
      .getWithAuth(
        `${baseUrl}/api/UserProduct/TransferUserProducts?fromUserId=${props.user.id}&toUserId=${transferTargetUser.id}`,
      )
      .then(() => {
        setTransferResult("success");
        setTransferDialogOpen(false);
        setTransferTargetUser(undefined);
        getRegisteredProductsForUser();
      })
      .catch((err: string) => {
        setTransferResult("error");
        setTransferErrorMessage(err ?? "Übertragung fehlgeschlagen.");
      })
      .finally(() => {
        setTransferring(false);
      });
  };

  function onChangeToolHerstellerForUser(key: string, selectedItems: string[]) {
    if (key) {
      setSelectedToolHerstellerKeys(selectedItems);
      if (selectedItems.includes(key)) {
        // Set DB Entry for this user
        fetchWrapper
          .post(baseUrl + "/api/account/settoolherstellerforuser", {
            UserGuid: props.user.id,
            ToolHerstellerGuid: key,
          })
          .then((result: any) => {
            if (key == "42") {
              // Wenn alle gewählt einmal die Liste neu vom Server laden. Ist einfacher ;-)
              getToolHerstellerForUser();
            }
          })
          .catch((error: any) => {});
      } else {
        // Remove DB Entry for this user
        fetchWrapper
          .post(baseUrl + "/api/account/removetoolherstellerforuser", {
            UserGuid: props.user.id,
            ToolHerstellerGuid: key,
          })
          .then((result: any) => {
            if (key == "42") {
              // Wenn alle abgewählt einmal die Liste neu vom Server laden. Ist einfacher ;-)
              getToolHerstellerForUser();
            }
          })
          .catch((error: any) => {});
      }
    }
  }
  function onChangeArbeitsgebieteForUser(key: string, selectedItems: string[]) {
    if (key) {
      setSelectedRoleKeys(selectedItems);
      if (selectedItems.includes(key)) {
        fetchWrapper
          .postWithAuth(`${baseUrl}/api/account/SetRoleForUser`, {
            UserId: props.user.id,
            RoleId: key,
          })
          .then((result: any) => {})
          .catch((error: any) => {});
      } else {
        fetchWrapper
          .postWithAuth(`${baseUrl}/api/account/RemoveRoleForUser`, {
            UserId: props.user.id,
            RoleId: key,
          })
          .then((result: any) => {})
          .catch((error: any) => {});
      }
    }
  }
  function onChangeRolesForUser(key: string, selectedItems: string[]) {
    if (key) {
      setSelectedRoleKeys(selectedItems);
      if (selectedItems.includes(key)) {
        fetchWrapper
          .postWithAuth(`${baseUrl}/api/account/SetRoleForUser`, {
            UserId: props.user.id,
            RoleId: key,
          })
          .then((result: any) => {})
          .catch((error: any) => {});
      } else {
        fetchWrapper
          .postWithAuth(`${baseUrl}/api/account/RemoveRoleForUser`, {
            UserId: props.user.id,
            RoleId: key,
          })
          .then((result: any) => {})
          .catch((error: any) => {});
      }
    }
  }

  const updateAccount = () => {
    // Update
    fetchWrapper
      .post(baseUrl + "/api/account/update", editUser)
      .then((result: any) => {
        props.onSave();
      })
      .catch((error: any) => {
        props.onSave();
      });
  };

  const deleteAccount = (sendMail: boolean) => {
    setDeleteError("");
    fetchWrapper
      .getWithAuth(
        baseUrl +
          `/api/account/DeleteAccount?id=${props.user.id}&sendMail=${sendMail}`,
      )
      .then((result: any) => {
        props.onSave();
      })
      .catch((error) => {
        setDeleteError(error);
      })
      .finally(() => {});
  };

  const getRegisteredProductsForUser = () => {
    fetchWrapper
      .getWithAuth(
        baseUrl + `/api/UserProduct/GetProductsForUserId?id=${props.user.id}`,
      )
      .then((result: any) => {
        setUserProducts(result);
      });
  };

  const getHasUserOpenRoleRequests = () => {
    fetchWrapper
      .getWithAuth(
        baseUrl +
          `/api/vertrieb/hasUserOpenRoleRequests?appUserGuid=${props.user.id}`,
      )
      .then((result: any) => {
        setHasUserOpenRoleRequests(result.message);
      });
  };

  useEffect(() => {
    if (props.getEmails == true) {
      getAllEmails();
    }
  }, [props.getEmails]);
  useEffect(() => {
    if (props.getRegisteredProducts == true) {
      getRegisteredProductsForUser();
    }
  }, [props.getRegisteredProducts]);
  useEffect(() => {
    if (props.saveEditedUser == true) {
      updateAccount();
    }
  }, [props.saveEditedUser]);
  useEffect(() => {
    if (props.setEmailUndefined == true) {
      setSelectedMail(undefined);
    }
  }, [props.setEmailUndefined]);
  useEffect(() => {
    props.selectedTabChange(selectedTabValue);
  }, [selectedTabValue]);

  useEffect(() => {
    // Laender laden
    getCountries();

    // Toolhersteller laden
    getToolHersteller();
    getToolHerstellerForUser();

    // Branchen laden
    getBranchen();

    // Arbeitsgebiete laden
    getArbeitsgebiete();

    // Rollen laden
    getRoles();
    getRolesForUser();

    // Prüfen ob Benutzer offene Rollen Anfragen hat
    getHasUserOpenRoleRequests();

    // Registrierte Systeme des Benutzers laden
    getRegisteredProductsForUser();

    //SaveButton wieder disablen
    props.disabledSaveButton(true);
  }, []);
  useEffect(() => {
    if (selectedTabValue == "mails") {
      getAllEmails();
    }
  }, [selectedTabValue]);
  useEffect(() => {
    if (editUser != props.user) {
      props.disabledSaveButton(false);
    }
  }, [editUser]);
  useEffect(() => {
    if (props.user && props.user.sprache) {
      getTemplateBody(props.user.sprache);
    } else {
      getTemplateBody("en");
    }
  }, [props.user]);

  const size = useWindowSize();
  useEffect(() => {
    if (props.isDialogDeleteUserOpen == true) {
      setDeleteUserDialogIsOpen(true);
    } else {
      setDeleteUserDialogIsOpen(false);
    }
  }, [props.isDialogDeleteUserOpen]);
  return (
    <div>
      {/* Benutzer Löschen Dialog */}
      <DialogDeleteUser
        onDelete={() => {
          props.closeDialogDeleteUser();
          deleteAccount(false);
        }}
        onCancel={() => {
          props.closeDialogDeleteUser();
        }}
        openDialog={deleteUserDialogIsOpen}
        onDeleteAndSendMail={() => {
          deleteAccount(true);
          props.closeDialogDeleteUser();
        }}
      />
      {/* Content */}
      <TabList
        defaultSelectedValue={"editUser"}
        onTabSelect={(ev, data) => {
          if (typeof data.value == "string") {
            setSelectedTabValue(data.value);
          }
        }}
      >
        <Tab value="editUser">{i18n.t<string>("editUser")}</Tab>
        <Tab value="sendMail">{i18n.t<string>("sendMail")}</Tab>
        <Tab value="mails">E-Mails</Tab>
        <Tab value="registeredSystems">
          {i18n.t<string>("registeredSystemsOfUser")}
        </Tab>
      </TabList>

      <div className="lueb-InnerContentBlockPadding2px">
        <Button
          disabled={freigabeAlleProdukteDisabled}
          appearance="transparent"
          onClick={() => {
            setFreigabeAlleProdukte(true);
            freigabeAlleProdukteUser();
          }}
          icon={<ShareAndroidRegular />}
        >
          Freigabe aller Produkte
        </Button>

        <Button
          appearance="transparent"
          icon={<PersonArrowRightRegular />}
          onClick={() => {
            setTransferResult(undefined);
            setTransferErrorMessage(undefined);
            setTransferTargetUser(undefined);
            setDialogUsers([]);
            setTransferDialogOpen(true);
            loadDialogUsers();
          }}
        >
          Produkte übertragen
        </Button>
      </div>

      {transferResult == "success" && (
        <MessageBar intent="success">
          <MessageBarBody>
            Produkte wurden erfolgreich übertragen.
          </MessageBarBody>
        </MessageBar>
      )}
      {transferResult == "error" && (
        <MessageBar intent="error">
          <MessageBarBody>{transferErrorMessage}</MessageBarBody>
        </MessageBar>
      )}

      {selectedTabValue == "editUser" && (
        <div className="lueb-ContentBlock">
          <StackShim horizontal tokens={{ childrenGap: 5 }} wrap={true}>
            <StackItemShim grow={1} style={{ paddingLeft: 5, paddingRight: 5 }}>
              <Field style={{ marginTop: "10px" }} label="ID">
                <Input
                  value={editUser.id}
                  readOnly
                  appearance="filled-darker"
                />
              </Field>
            </StackItemShim>
            <StackItemShim grow={1} style={{ paddingLeft: 5, paddingRight: 5 }}>
              <Field style={{ marginTop: "10px" }} label="Titel">
                <Input
                  value={editUser.anrede}
                  onChange={(ev, data) => {
                    var tempUser = { ...editUser };
                    tempUser.anrede = data.value;
                    setEditUser(tempUser);
                  }}
                />
              </Field>
            </StackItemShim>
            <StackItemShim grow={1} style={{ paddingLeft: 5, paddingRight: 5 }}>
              <Field style={{ marginTop: "10px" }} label="Vorname">
                <Input
                  value={editUser.vorname}
                  onChange={(ev, data) => {
                    var tempUser = { ...editUser };
                    tempUser.vorname = data.value;
                    setEditUser(tempUser);
                  }}
                />
              </Field>
            </StackItemShim>
            <StackItemShim grow={1} style={{ paddingLeft: 5, paddingRight: 5 }}>
              <Field style={{ marginTop: "10px" }} label="Nachname">
                <Input
                  value={editUser.nachname}
                  onChange={(ev, data) => {
                    var tempUser = { ...editUser };
                    tempUser.nachname = data.value;
                    setEditUser(tempUser);
                  }}
                />
              </Field>
            </StackItemShim>
          </StackShim>
          <StackShim horizontal tokens={{ childrenGap: 5 }} wrap={true}>
            <StackItemShim grow={1} style={{ paddingLeft: 5, paddingRight: 5 }}>
              <Field style={{ marginTop: "10px" }} label="E-Mail">
                <Input
                  appearance="filled-darker"
                  value={editUser.email}
                  readOnly
                  contentAfter={
                    editUser.emailConfirmed ? (
                      <CheckmarkFilled color="green" />
                    ) : (
                      <DismissFilled color="red" />
                    )
                  }
                />
              </Field>
            </StackItemShim>

            <StackItemShim grow={1} style={{ paddingLeft: 5, paddingRight: 5 }}>
              <Field style={{ marginTop: "10px" }} label="Firma">
                <Input
                  value={editUser.firma}
                  onChange={(ev, data) => {
                    var tempUser = { ...editUser };
                    tempUser.firma = data.value;
                    setEditUser(tempUser);
                  }}
                />
              </Field>
            </StackItemShim>

            <StackItemShim grow={1} style={{ paddingLeft: 5, paddingRight: 5 }}>
              <Field style={{ marginTop: "10px" }} label="Abteilung">
                <Input
                  value={editUser.abteilung}
                  onChange={(ev, data) => {
                    var tempUser = { ...editUser };
                    tempUser.abteilung = data.value;
                    setEditUser(tempUser);
                  }}
                />
              </Field>
            </StackItemShim>

            <StackItemShim grow={1} style={{ paddingLeft: 5, paddingRight: 5 }}>
              <Field style={{ marginTop: "10px" }} label="Website">
                <Input
                  value={editUser.webseite}
                  onChange={(ev, data) => {
                    var tempUser = { ...editUser };
                    tempUser.webseite = data.value;
                    setEditUser(tempUser);
                  }}
                />
              </Field>
            </StackItemShim>
          </StackShim>
          <StackShim horizontal tokens={{ childrenGap: 5 }} wrap={true}>
            <StackItemShim grow={1} style={{ paddingLeft: 5, paddingRight: 5 }}>
              <Field style={{ marginTop: "10px" }} label="Straße">
                <Input
                  value={editUser.strasse}
                  onChange={(ev, data) => {
                    var tempUser = { ...editUser };
                    tempUser.strasse = data.value;
                    setEditUser(tempUser);
                  }}
                />
              </Field>
            </StackItemShim>

            <StackItemShim grow={1} style={{ paddingLeft: 5, paddingRight: 5 }}>
              <Field style={{ marginTop: "10px" }} label="PLZ">
                <Input
                  value={editUser.postleitzahl}
                  onChange={(ev, data) => {
                    var tempUser = { ...editUser };
                    tempUser.postleitzahl = data.value;
                    setEditUser(tempUser);
                  }}
                />
              </Field>
            </StackItemShim>

            <StackItemShim grow={1} style={{ paddingLeft: 5, paddingRight: 5 }}>
              <Field style={{ marginTop: "10px" }} label="Stadt">
                <Input
                  value={editUser.stadt}
                  onChange={(ev, data) => {
                    var tempUser = { ...editUser };
                    tempUser.stadt = data.value;
                    setEditUser(tempUser);
                  }}
                />
              </Field>
            </StackItemShim>

            {countries.length > 0 && (
              <StackItemShim
                grow={1}
                style={{ paddingLeft: 5, paddingRight: 5 }}
              >
                <Field style={{ marginTop: "10px" }} label="Land">
                  <Dropdown
                    onOptionSelect={(ev, val) => {
                      var tempUser = { ...editUser };
                      if (val.optionValue) {
                        tempUser.landGuid = val.optionValue;
                      }
                      setEditUser(tempUser);
                    }}
                    defaultSelectedOptions={[editUser.landGuid]}
                    defaultValue={
                      countries.find(
                        (x) => x.key.toLocaleString() == editUser.landGuid,
                      )?.text
                    }
                    value={
                      countries.find(
                        (x) => x.key.toLocaleString() == editUser.landGuid,
                      )?.text
                    }
                  >
                    {countries.map((item: { key: string; text: string }) => {
                      return <Option value={item.key}>{item.text}</Option>;
                    })}
                  </Dropdown>
                </Field>
              </StackItemShim>
            )}
          </StackShim>
          <StackShim horizontal tokens={{ childrenGap: 5 }} wrap={true}>
            <StackItemShim grow={1} style={{ paddingLeft: 5, paddingRight: 5 }}>
              <Field style={{ marginTop: "10px" }} label="Sprache">
                <Input
                  appearance="filled-darker"
                  readOnly
                  value={editUser.sprache}
                />
              </Field>
            </StackItemShim>
            <StackItemShim grow={1} style={{ paddingLeft: 5, paddingRight: 5 }}>
              <Field style={{ marginTop: "10px" }} label="Telefon">
                <Input
                  value={editUser.telefonNummer}
                  onChange={(ev, data) => {
                    var tempUser = { ...editUser };
                    tempUser.telefonNummer = data.value;
                    setEditUser(tempUser);
                  }}
                />
              </Field>
            </StackItemShim>
            <StackItemShim grow={1} style={{ paddingLeft: 5, paddingRight: 5 }}>
              <Field style={{ marginTop: "10px" }} label="Kundennummer">
                <Input
                  value={editUser.kundennummer}
                  onChange={(ev, data) => {
                    var tempUser = { ...editUser };
                    tempUser.kundennummer = data.value;
                    setEditUser(tempUser);
                  }}
                />
              </Field>
            </StackItemShim>
          </StackShim>
          <StackShim tokens={{ childrenGap: 5 }} wrap={true}>
            <StackItemShim grow={1} style={{ paddingLeft: 5, paddingRight: 5 }}>
              <Field style={{ marginTop: "10px" }}>
                <Checkbox
                  checked={editUser.isDeleted}
                  onChange={(ev, data) => {
                    var tempUser = { ...editUser };
                    if (typeof data.checked == "boolean") {
                      tempUser.isDeleted = data.checked;
                    }
                    setEditUser(tempUser);
                  }}
                  label="Gesperrt"
                />
              </Field>
            </StackItemShim>{" "}
            <StackItemShim grow={1} style={{ paddingLeft: 5, paddingRight: 5 }}>
              <Field>
                <Checkbox
                  checked={editUser.preiseSichtbar}
                  onChange={(ev, data) => {
                    var tempUser = { ...editUser };
                    if (typeof data.checked == "boolean") {
                      tempUser.preiseSichtbar = data.checked;
                    }
                    setEditUser(tempUser);
                  }}
                  label="Preise sichtbar"
                />
              </Field>
            </StackItemShim>
          </StackShim>

          <StackShim horizontal tokens={{ childrenGap: 5 }} wrap={true}>
            <StackItemShim grow={1} style={{ paddingLeft: 5, paddingRight: 5 }}>
              <Field style={{ marginTop: "10px" }} label="Registriert am">
                <Input
                  readOnly
                  appearance="filled-darker"
                  value={
                    editUser.registrationDate
                      ? new Date(editUser.registrationDate).toLocaleString()
                      : ""
                  }
                />
              </Field>
            </StackItemShim>
            <StackItemShim grow={1} style={{ paddingLeft: 5, paddingRight: 5 }}>
              <Field style={{ marginTop: "10px" }} label="Letzter Login">
                <Input
                  readOnly
                  appearance="filled-darker"
                  value={
                    editUser.lastLoginDate
                      ? new Date(editUser.lastLoginDate).toLocaleString()
                      : ""
                  }
                />
              </Field>
            </StackItemShim>
          </StackShim>
          <StackShim horizontal tokens={{ childrenGap: 5 }} wrap={true}>
            <StackItemShim grow={1} style={{ paddingLeft: 5, paddingRight: 5 }}>
              <Field
                style={{ marginTop: "10px" }}
                label={i18n.t<string>("toolHersteller")}
              >
                <Dropdown
                  multiselect
                  onOptionSelect={(ev, data) => {
                    if (data.optionValue) {
                      onChangeToolHerstellerForUser(
                        data.optionValue,
                        data.selectedOptions,
                      );
                    }
                  }}
                  value={
                    selectedToolHerstellerKeys
                      ? selectedToolHerstellerKeys
                          .map((item) => {
                            return toolHersteller.find((x) => x.key == item)
                              ?.text
                              ? toolHersteller.find((x) => x.key == item)?.text
                              : item;
                          })
                          .join(", ")
                      : ""
                  }
                  defaultSelectedOptions={selectedToolHerstellerKeys}
                  selectedOptions={selectedToolHerstellerKeys}
                >
                  {toolHersteller.map((item: { key: string; text: string }) => {
                    return (
                      <Option value={item.key.toLocaleString()}>
                        {item.text}
                      </Option>
                    );
                  })}
                </Dropdown>
              </Field>
            </StackItemShim>

            <StackItemShim grow={1} style={{ paddingLeft: 5, paddingRight: 5 }}>
              <Field
                style={{ marginTop: "10px" }}
                label={i18n.t<string>("branchen")}
              >
                <Dropdown
                  multiselect
                  onOptionSelect={(ev, data) => {
                    if (data.optionValue) {
                      onChangeBranchenForUser(
                        data.optionValue,
                        data.selectedOptions,
                      );
                    }
                  }}
                  value={
                    selectedBranchenKeys
                      ? selectedBranchenKeys
                          .map((item) => {
                            return branchen.find((x) => x.key == item)?.text
                              ? branchen.find((x) => x.key == item)?.text
                              : item;
                          })
                          .join(", ")
                      : ""
                  }
                  defaultSelectedOptions={selectedBranchenKeys}
                  selectedOptions={selectedBranchenKeys}
                >
                  {branchen.map((item: { key: string; text: string }) => {
                    return (
                      <Option value={item.key.toLocaleString()}>
                        {item.text}
                      </Option>
                    );
                  })}
                </Dropdown>
              </Field>
            </StackItemShim>

            <StackItemShim grow={1} style={{ paddingLeft: 5, paddingRight: 5 }}>
              <Field
                style={{ marginTop: "10px" }}
                label={i18n.t<string>("arbeitsgebiete")}
              >
                <Dropdown
                  multiselect
                  onOptionSelect={(ev, data) => {
                    if (data.optionValue) {
                      onChangeArbeitsgebieteForUser(
                        data.optionValue,
                        data.selectedOptions,
                      );
                    }
                  }}
                  value={
                    selectedArbeitsgebieteKeys
                      ? selectedArbeitsgebieteKeys
                          .map((item) => {
                            return arbeitsgebiete.find((x) => x.key == item)
                              ?.text
                              ? arbeitsgebiete.find((x) => x.key == item)?.text
                              : item;
                          })
                          .join(", ")
                      : ""
                  }
                  defaultSelectedOptions={selectedArbeitsgebieteKeys}
                  selectedOptions={selectedArbeitsgebieteKeys}
                >
                  {arbeitsgebiete.map((item: { key: string; text: string }) => {
                    return (
                      <Option value={item.key.toLocaleString()}>
                        {item.text}
                      </Option>
                    );
                  })}
                </Dropdown>
              </Field>
            </StackItemShim>
            <StackItemShim grow={1} style={{ paddingLeft: 5, paddingRight: 5 }}>
              <Field
                style={{ marginTop: "10px" }}
                label={i18n.t<string>("roles")}
              >
                <Dropdown
                  multiselect
                  onOptionSelect={(ev, data) => {
                    if (data.optionValue) {
                      onChangeRolesForUser(
                        data.optionValue,
                        data.selectedOptions,
                      );
                    }
                  }}
                  value={
                    selectedRoleKeys
                      ? selectedRoleKeys
                          .map((item) => {
                            return roles.find((x) => x.key == item)?.text
                              ? roles.find((x) => x.key == item)?.text
                              : item;
                          })
                          .join(", ")
                      : ""
                  }
                  defaultSelectedOptions={selectedRoleKeys}
                  selectedOptions={selectedRoleKeys}
                >
                  {roles.map((item: { key: string; text: string }) => {
                    return (
                      <Option value={item.key.toLocaleString()}>
                        {item.text}
                      </Option>
                    );
                  })}
                </Dropdown>
              </Field>
            </StackItemShim>
          </StackShim>

          {hasUserOpenRoleRequests && (
            <div style={{ marginTop: 10 }}>
              <MessageBar intent="warning">
                Benutzer hat offene Modul-Anfrage, bitte prüfen!
              </MessageBar>
            </div>
          )}
          {deleteError != "" && (
            <MessageBar intent="error">{deleteError}</MessageBar>
          )}
        </div>
      )}

      {selectedTabValue == "sendMail" && (
        <SendMail
          user={props.user}
          onEmailSent={() => getAllEmails()}
          sendMail={props.sendMail}
          onSaveButtonDiasabled={(item: boolean) => {
            props.sendMailButtonDisabled(item);
          }}
        />
      )}
      {selectedTabValue == "mails" && (
        <div className="lueb-ContentBlock">
          {!selectedMail && (
            <div>
              <LuebPagedDataGrid
                columns={emailColumns}
                items={emails}
                resizableColumns={true}
                columnSizingOptions={{
                  empfängerId: { minWidth: 250, defaultWidth: 280 },
                  betreffId: { minWidth: 250, defaultWidth: 550 },
                  gesendetId: { minWidth: 100, defaultWidth: 150 },
                }}
              />
              {emails.length < 1 && (
                <MessageBar intent="info">
                  {i18n.t<string>("noItemsFound")}
                </MessageBar>
              )}
            </div>
          )}
          {selectedMail && (
            <div
              dangerouslySetInnerHTML={{
                __html: selectedMail
                  ? templateBody.replace("{content}", selectedMail.body)
                  : "<div></div>",
              }}
            />
          )}
        </div>
      )}
      {selectedTabValue == "registeredSystems" && (
        <div>
          <div className="lueb-ContentBlock">
            <Field label={<h5>{i18n.t<string>("ownProducts")}</h5>}>
              <LuebPagedDataGrid
                columns={columns}
                items={userProducts.ownProductslist}
                resizableColumns={true}
                columnSizingOptions={{}}
              />
              {userProducts.ownProductslist.length < 1 && (
                <MessageBar intent="info">
                  {i18n.t<string>("noItemsFound")}
                </MessageBar>
              )}
            </Field>
          </div>

          <div className="lueb-ContentBlock">
            <Field label={<h5>{i18n.t<string>("sharedProducts")}</h5>}>
              <LuebPagedDataGrid
                columns={columns}
                items={userProducts.sharedProductslist}
                resizableColumns={true}
                columnSizingOptions={{}}
              />
              {userProducts.sharedProductslist.length < 1 && (
                <MessageBar intent="info">
                  {i18n.t<string>("noItemsFound")}
                </MessageBar>
              )}
            </Field>
          </div>
        </div>
      )}

      <Dialog
        open={transferDialogOpen}
        onOpenChange={(_, data) => {
          if (!transferring) setTransferDialogOpen(data.open);
        }}
      >
        <DialogSurface>
          <DialogBody>
            <DialogTitle>Schraubsysteme übertragen</DialogTitle>
            <DialogContent>
              <p>
                Alle Schraubsysteme von{" "}
                <strong>
                  {props.user.vorname} {props.user.nachname}
                </strong>{" "}
                werden an den ausgewählten Benutzer übertragen.
              </p>
              <Field label="Ziel-Benutzer">
                <Combobox
                  placeholder="Benutzer suchen..."
                  value={
                    transferTargetUser
                      ? `${transferTargetUser.vorname} ${transferTargetUser.nachname} (${transferTargetUser.email})`
                      : ""
                  }
                  onOptionSelect={(_, data) => {
                    const found = dialogUsers.find(
                      (u) => u.id === data.optionValue,
                    );
                    setTransferTargetUser(found);
                  }}
                >
                  {loadingDialogUsers ? (
                    <Option value="" text="Laden...">
                      Laden...
                    </Option>
                  ) : (
                    dialogUsers
                      .filter((u) => u.id !== props.user.id)
                      .map((u) => (
                        <Option
                          key={u.id}
                          value={u.id}
                          text={`${u.vorname} ${u.nachname} (${u.email})`}
                        >
                          {u.vorname} {u.nachname} ({u.email})
                        </Option>
                      ))
                  )}
                </Combobox>
              </Field>
              {transferResult === "error" && (
                <MessageBar intent="error" style={{ marginTop: 12 }}>
                  <MessageBarBody>
                    {transferErrorMessage ?? "Übertragung fehlgeschlagen."}
                  </MessageBarBody>
                </MessageBar>
              )}
            </DialogContent>
            <DialogActions>
              <Button
                appearance="primary"
                disabled={!transferTargetUser || transferring}
                icon={transferring ? <Spinner size="tiny" /> : undefined}
                onClick={transferUserProducts}
              >
                Übertragen
              </Button>
              <Button
                appearance="secondary"
                disabled={transferring}
                onClick={() => setTransferDialogOpen(false)}
              >
                Abbrechen
              </Button>
            </DialogActions>
          </DialogBody>
        </DialogSurface>
      </Dialog>
    </div>
  );
}

export default EditUserPage;
